import { render, staticRenderFns } from "./_footer.vue?vue&type=template&id=d4a421fc&scoped=true&"
import script from "./_footer.vue?vue&type=script&lang=js&"
export * from "./_footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a421fc",
  null
  
)

export default component.exports